const PERSONA_QUERY_KEYS = "persona";

export const personaQueryKeys = {
  all: [PERSONA_QUERY_KEYS] as const,
  currentCitizen: function currentCitizen() {
    return [PERSONA_QUERY_KEYS, "currentCitizen"] as const;
  },
};
